import { render, staticRenderFns } from "./CustomAuth.vue?vue&type=template&id=59a3a8db&"
import script from "./CustomAuth.vue?vue&type=script&lang=ts&"
export * from "./CustomAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports